import { render, staticRenderFns } from "./uninstalls.vue?vue&type=template&id=3e1b8443"
import script from "./uninstalls.vue?vue&type=script&lang=js"
export * from "./uninstalls.vue?vue&type=script&lang=js"
import style0 from "./uninstalls.vue?vue&type=style&index=0&id=3e1b8443&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports